const getDefaultState = () => {
  return {
    smses: [],
    sms: {},
    totalItems: null,
    totalPage: null,
    lastSms: null,
    smsRecipientReport: [],
    recipientReportTotalItems: null,
    recipientReportTotalPage: null,
    unreadCount: 0,
    activeRecipient: {},
    currentMessageList: [],
    smsReport: [],
    smsReportTotalItems: null,
    smsReportTotalPage: null,
    smsResellerReport: [],
    smsResellerTotalPage: null,
    smsResellerTotalItems: null,
    loading: true,
  };
};

const state = getDefaultState();

export { state, getDefaultState };
